import { Copy } from "lucide-react";
import { useToast } from "./Toast";

/**
 * A stored payload, pretty-printed, with a copy button — for log rows where
 * the exact JSON is the answer. Renders nothing for an empty value.
 */
const JsonBlock = ({ title, value }) => {
  const toast = useToast();
  if (value === undefined || value === null || (typeof value === "object" && Object.keys(value).length === 0)) return null;

  const text = typeof value === "string" ? value : JSON.stringify(value, null, 2);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast("Copied", "success");
    } catch {
      toast("Couldn't copy", "error");
    }
  };

  return (
    <div className="overflow-hidden rounded-xl border border-ink-200/70 bg-white">
      <div className="flex items-center justify-between border-b border-ink-150 px-3.5 py-2">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-ink-500">{title}</p>
        <button type="button" onClick={copy} className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[11px] text-ink-400 hover:bg-ink-100 hover:text-ink-700">
          <Copy size={11} aria-hidden />
          Copy
        </button>
      </div>
      <pre className="max-h-80 overflow-auto whitespace-pre-wrap break-words px-3.5 py-3 font-mono text-[11.5px] leading-relaxed text-ink-700">{text}</pre>
    </div>
  );
};

export default JsonBlock;
